export default "__VITE_ASSET__6ca396ab__"